

























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import RespondecoIcon from '@/shared/components/respondeco-icon.vue'

@Component({
  name: 'RespondecoUnsavedBar',
  components: { RespondecoIcon, UnifyButton },
})
export default class UnsavedBar extends Vue {
  @Prop() public visible = false

  public cancel() {
    this.$emit('cancel')
  }

  public save() {
    this.$emit('save')
  }
}
